<template>
  <div class="member-box-autoKey">
    <div class="search">
      <el-input v-model="search" placeholder="搜索选项关键字" maxlength="20" clearable @input="timeWait(300)">
        <i slot="prefix" class="el-input__icon icon iconfont iconicon_search1"></i>
      </el-input>
    </div>
    <div class="wrap">
      <div class="srcoll-box">
        <div v-show="computedMemberList.length > 0">
          <div class="item" @click="empty">
            <span class="reviewPrincipal-no">无</span>
          </div>
          <div class="item" v-for="(item, index) in computedMemberList" :class="selected.indexOf(item) > -1 ? 'active' : ''"  :key="index" @click="itemClick(item)">
            <toolTip class="reviewPrincipal" :title="item" :maxWidth="'82%'">
              <span >{{ item }}</span>
            </toolTip>
            <i class="icon iconfont iconicon_selected_more_task selected"></i>
          </div>
        </div>
        <div class="new-add-tag">
          <nothing v-if="computedMemberList.length === 0" width="88px" :config="{ tip: '暂无搜索结果', btnText: '', type: 'img_search' }"></nothing>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'MemberSelect',
  props: {
    // 默认选中
    checkedMember: {
      type: [ Array],
      default: () => {
        return []
      }
    },
    list:{
      type: [ Array],
      default: () => {
        return []
      }
    },
    visible: Boolean
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    computedMemberList() {
      if (this.search === '') {
        return this.list
      }
      return this.list.filter(item => item.indexOf(this.search) > -1)
    },
    selected() {
      return this.checkedMember
    }
  },
  methods: {
    itemClick(val) {
      // let arr = JSON.parse(JSON.stringify(this.checkedMember))
      // let idx = arr.findIndex(res => res.key === itemData.key)
      // if(idx > -1){
      //   arr.splice(idx,1)
      // }else {
      //   arr.push(itemData)
      // }
      // this.$emit('change',arr)
      let arr = JSON.parse(JSON.stringify(this.selected))
      let fl = arr.find((res, index) => {
        if (res === val) {
          arr.splice(index, 1)
          return true
        } else {
          return false
        }
      })
      if (!fl) {
        arr.push(val)
      }
      this.$emit('change', arr)
    },
    empty() {
      this.$emit('empty')
    },
  }
}
</script>

<style lang="scss" scoped>
.empty-search {
  display: flex;
  justify-content: center;
  align-items: center;
}

.member-box-autoKey {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(25, 24, 67, 0.16);
  border-radius: 4px;
  .search {
    box-sizing: border-box;
    padding: 24px;
  }
  .wrap {
    min-height: 55px;
    overflow: hidden;
    .item {
      font-size: 14px;
      cursor: pointer;
      height: 40px;
      padding: 0 24px 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .selected {
        font-size: inherit;
        visibility: hidden;
      }
      &.active {
        color: $color-active !important;
        /deep/ {
          .name-txt {
            color: $color-active !important;
          }
        }
        .selected {
          color: inherit;
          visibility: visible;
        }
      }
    }
  }
  .srcoll-box {
    position: relative;
    width: 100%;
    min-height: 55px;
    max-height: 400px;
    overflow: auto;
    overflow: overlay;
    margin-bottom: 8px;
    .new-add-tag{
      padding: 0 16px;
      .nothing-box {
        position: relative;
        top: 50%;
        transform: translate(-50% ,0);
      }
      .wf-button{
        width: 100%;
      }
    }
  }
  .reviewPrincipal {
    height: 28px;
    border-radius: 4px;
    display: inline-block;
    line-height: 28px;
    text-align: center;
    padding: 0 8px;
    background-color: rgba(32, 32, 32, 0.08);
    color: rgba(32, 32, 32, 0.8);
  }
  .reviewPrincipal-no {
    width: 52px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: rgba(32,32,40,0.1);
    border-radius: 4px;
  }
}
</style>
